<section class="hero-section">
    <div class="hero-section__content">
      <h1 class="hero-section__title">
        <span>D</span>atahub
      </h1>
      <h2 class="hero-section__title--sub">
        Сите твои потреби на едно место
      </h2>
      <div class="hero-section__search">
         <app-search></app-search>
      </div>
    </div>
    <div class="hero-section__categories">
      <!-- <FiltersHome /> -->
    </div>
</section>